import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import MartPage from "@/pages/MartPage";
import WhatsAppButton from "@/components/WhatsAppButton";
import { Navigate } from "react-router-dom";

function App() {
  return (
    <div className="App bg-[#061536] min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/mart" element={<MartPage />} />
          <Route path="/shop" element={<Navigate to="/mart" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <WhatsAppButton />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
